import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import NumberFormat from "react-number-format";
import { Chart } from "primereact/chart";

import moment from "moment";
import "moment/locale/es";

import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { es } from "date-fns/locale";

import "./dashboard.css";

import { fetchConToken } from "../../helpers/fetch";
// import { lastMonth } from '../../helpers/general'
import { dashboardSetFiltersList } from "../../redux/actions/pptos";

moment.locale("es");

export const Dashboard = () => {
  const dispatch = useDispatch();
  const info = useSelector((state) => state.general.info);
  const filtersDefaultDate = useSelector(
    (state) => state.ppto.dashboard_filters,
  );

  const [loadingData, setLoadingData] = useState("");
  const [dataSetBar, setDataSetBar] = useState([]);
  const [dataSetPie, setDataSetPie] = useState([]);
  const [totales, setTotales] = useState(null);
  const [filters, setFilters] = useState({
    time: filtersDefaultDate?.time || "year",
    dateFrom: filtersDefaultDate?.fecha_desde || new Date(),
    dateTo: filtersDefaultDate?.fecha_hasta || new Date(),
    id_moneda: info.local_id_moneda,
  });

  const getData = useCallback(async () => {
    try {
      setLoadingData("Consultando datos...");
      const params = new URLSearchParams(filters).toString();
      const resp = await fetchConToken(`dashboard/summary/?${params}`);
      const res = await resp.json();

      if (res.ok) {
        setLoadingData("Cargando datos...");
        setTotales(res.data[0].totales);
        setDataSetBar(res.data[0].dataMonthly);
        setDataSetPie(res.data[0].dataArea);
        console.log("---data area---", res.data[0].dataArea);
        setLoadingData("");
      }
    } catch (error) {
      console.log(error);
      setLoadingData("");
    }
  }, [filters]);

  const handleChangeDate = (newValue) => {
    setFilters({
      ...filters,
      dateFrom: newValue,
    });
  };

  useEffect(() => {
    getData();

    dispatch(
      dashboardSetFiltersList({
        time: filters?.time,
        fecha_desde: filters?.dateFrom,
        fecha_hasta: filters?.dateTo,
      }),
    );
  }, [filters, dispatch, getData]);

  return (
    <div className="p-container">
      <h1 className="p-title ml-4 md:ml-0">Dashboard</h1>

      <div className="ml-4 md:ml-0">
        <DateFilters
          filters={filters}
          setFilters={setFilters}
          handleChangeDate={handleChangeDate}
        />
      </div>

      {loadingData === "" ? (
        <>
          <SummaryTotals filters={filters} totales={totales} />
          <SummaryGrap
            filters={filters}
            dataSetBar={dataSetBar}
            dataSetPie={dataSetPie}
          />
        </>
      ) : (
        <div className="text-start mt-3">
          <div class="spinner-border p-color-primary" role="status">
            <span class="visually-hidden" style={{ color: "red" }}>
              Loading...
            </span>
          </div>
          <div>{loadingData}</div>
        </div>
      )}
    </div>
  );
};

const SummaryTotals = ({ totales }) => {
  const { access } = useSelector((state) => state.auth);
  const {
    local_moneda: moneda,
    local_simbolo: simbolo,
    local_separacion_miles: separacion_miles,
    local_separacion_decimales: separacion_decimales,
  } = useSelector((state) => state.general.info);

  return (
    <div className="m-2 md:m-0">
      <div className="ms-1 mt-4">
        <div>
          <h5>
            Resumen{" "}
            <label
              style={{
                color: "#7d7a7d",
                fontSize: "16px",
                textTransform: "capitalize",
              }}
            >
              ({moneda || "soles"})
            </label>
          </h5>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 p-dash-cards mt-2">
        <div className="d-flex flex-column p-3 justify-content-top align-items-left">
          <span>
            Proyectos <label style={{ color: "#7d7a7d" }}>(aprobados)</label>
          </span>
          <span
            className="mt-2"
            style={{ fontSize: "22px", fontWeight: "bold" }}
          >
            {totales?.budgets || 0}
          </span>
        </div>

        <div className="d-flex flex-column p-3 justify-content-top align-items-left">
          <span className="d-flex align-items-center">
            <label className="tabla-punto-cliente-d"></label>
            <span className="ms-1">Ventas</span>
          </span>
          <span
            className="mt-2"
            style={{ fontSize: "20px", fontWeight: "bold" }}
          >
            <NumberFormat
              value={totales?.sales ? parseFloat(totales?.sales) : 0}
              displayType={"text"}
              thousandSeparator={separacion_miles || ","}
              decimalSeparator={separacion_decimales || "."}
              prefix={`${simbolo || "S/"} `}
              decimalScale={2}
              fixedDecimalScale={2}
            />
          </span>
        </div>

        {access.a22 ? (
          <div className="d-flex flex-column p-3 justify-content-top align-items-left">
            <span className="d-flex align-items-center">
              <label className="tabla-punto-ppto-d"></label>
              <span className="ms-1">
                Gastos <label style={{ color: "#7d7a7d" }}>(directos)</label>
              </span>
            </span>
            <div
              className="d-flex justify-content-between align-items-center mt-2"
              style={{ fontSize: "20px", fontWeight: "bold" }}
            >
              <NumberFormat
                value={parseFloat(totales?.expenses) || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles || ","}
                decimalSeparator={separacion_decimales || "."}
                prefix={`${simbolo || "S/"} `}
                decimalScale={2}
                fixedDecimalScale={2}
              />
              <NumberFormat
                value={
                  (parseFloat(totales?.expenses) / parseFloat(totales?.sales)) *
                  100
                }
                displayType={"text"}
                thousandSeparator={separacion_miles || ","}
                decimalSeparator={separacion_decimales || "."}
                suffix="%"
                decimalScale={2}
                fixedDecimalScale={2}
              />
            </div>
          </div>
        ) : (
          <div className="col ms-3 p-3" style={{ background: "none" }}></div>
        )}

        {access.a22 ? (
          <div className="d-flex flex-column p-3 justify-content-top align-items-left">
            <span className="d-flex align-items-center">
              <label className="tabla-punto-rentabilidad-d"></label>
              <span className="ms-1">
                Rentabilidad <label style={{ color: "#7d7a7d" }}>(real)</label>
              </span>
            </span>
            <div
              className="d-flex justify-content-between align-items-center mt-2"
              style={{ fontSize: "20px", fontWeight: "bold" }}
            >
              <NumberFormat
                value={parseFloat(totales?.profits) || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles || ","}
                decimalSeparator={separacion_decimales || "."}
                prefix={`${simbolo || "S/"} `}
                decimalScale={2}
                fixedDecimalScale={2}
              />
              <NumberFormat
                value={
                  (parseFloat(totales?.profits) / parseFloat(totales?.sales)) *
                  100
                }
                displayType={"text"}
                thousandSeparator={separacion_miles || ","}
                decimalSeparator={separacion_decimales || "."}
                suffix="%"
                decimalScale={2}
                fixedDecimalScale={2}
              />
            </div>
          </div>
        ) : (
          <div className="col ms-3 p-3" style={{ background: "none" }}></div>
        )}
      </div>
    </div>
  );
};

const DateFilters = ({ filters, setFilters, handleChangeDate }) => {
  return (
    <div className="d-flex mt-3">
      {/* <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off"
                    checked={filters.time === 'year' && 'checked'}
                    onChange={() => setFilters({ ...filters, time: 'year' })}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio2" style={{ color: filters.time === 'year' ? '#8E24AA' : '#595759' }}>
                    Vista mensual (<span style={{ textTransform: 'capitalize' }}>Año</span>{' '}{moment(filters.dateFrom).format('YYYY')})
                </label>
            </div> */}
      <div className="p-text-date-year">
        <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
          <DatePicker
            views={["year"]}
            label="Año"
            openTo="year"
            name="dateFrom"
            // minDate={new Date('2020-01-01')}
            value={filters.dateFrom}
            onChange={handleChangeDate}
            renderInput={(params) => (
              <TextField {...params} helperText={null} />
            )}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

const SummaryGrap = ({ filters, dataSetBar, dataSetPie }) => {
  const { access } = useSelector((state) => state.auth);

  return (
    <>
      <div
        className="row mt-4"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <div className="col d-flex justify-content-center">
          <BarChart dataSet={dataSetBar} color={"#9ae3a1"} access={access} />
        </div>
        <div className="col d-flex justify-content-center mt-5">
          <h5 style={{ fontSize: "12px" }}>Ventas por unidad de negocio</h5>
          <PieChart
            dataSet={dataSetPie}
            color={["#9ae3a1", "#9ac89e", "#418f48"]}
          />
        </div>
      </div>
    </>
  );
};

const PieChart = ({ dataSet, color }) => {
  let labelsSet = [];
  let valuesSet = [];
  let colorSet = [];

  for (let x = 0; x < dataSet.length; x++) {
    labelsSet = [...labelsSet, dataSet[x].nombre];
    valuesSet = [...valuesSet, dataSet[x].value];
    colorSet = [...colorSet, dataSet[x].color];
  }

  const chartData = {
    labels: labelsSet,
    datasets: [
      {
        data: valuesSet,
        backgroundColor: colorSet,
        hoverBackgroundColor: colorSet,
      },
    ],
  };

  const [lightOptions] = useState({
    plugins: {
      legend: {
        labels: {
          color: "#495057",
          usePointStyle: true,
        },
      },
    },
  });

  return (
    <Chart
      type="pie"
      data={chartData}
      options={lightOptions}
      style={{ width: "60%" }}
    />
  );
};

const BarChart = ({ dataSet = [], color, access }) => {
  const { sales, buys, profit } = dataSet;
  // console.log('--dataSet--', dataSet)

  let basicData = {};

  if (access.a22) {
    basicData = {
      labels: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
      datasets: [
        {
          label: "Ventas",
          backgroundColor: "#b6cfff",
          data: sales,
        },
        {
          label: "Gastos directos",
          backgroundColor: "#f9a5a6",
          data: buys,
        },
        {
          label: "Rentabilidad real",
          backgroundColor: "#9dfb9d",
          data: profit,
        },
      ],
    };
  } else {
    basicData = {
      labels: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
      datasets: [
        {
          label: "Ventas",
          backgroundColor: "#b6cfff",
          data: sales,
        },
        // {
        //     label: 'Gastos directos',
        //     backgroundColor: '#f9a5a6',
        //     data: buys
        // },
        // {
        //     label: 'Rentabilidad',
        //     backgroundColor: '#9dfb9d',
        //     data: profit
        // }
      ],
    };
  }

  let basicOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        labels: {
          color: "#495057",
          usePointStyle: true,
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  return (
    <Chart
      type="bar"
      data={basicData}
      options={basicOptions}
      style={{ position: "relative", width: "100%" }}
    />
  );
};

// const GrowthRate = ({ rate }) => {
//     return (
//         <>
//             <span style={{ fontSize: '13px', color: '#7d7a7d', marginTop: '5px' }}>
//                 {parseFloat(parseFloat(rate).toFixed(1)) || 0}
//                 <label style={{ fontSize: '12px' }}>%</label>
//                 {rate < 0 && <i className="bi bi-arrow-down" style={{ color: 'red' }}></i>}
//                 {rate > 0 && <i className="bi bi-arrow-up" style={{ color: 'green' }}></i>}
//                 {rate == 0 && <i className="bi bi-arrow-up" style={{ color: '#7d7a7d' }}></i>}
//             </span >
//             <span style={{ fontSize: '11px', color: '#7d7a7d' }}>Comparado mes anterior ({lastMonth})</span>
//         </>
//     )
// }
